import Cookies from 'js-cookie'
import EnvBase from "@/env";

var PT = EnvBase.PT;
const app = {
    state: {
        sidebar: {
            opened: !+Cookies.get('sidebarStatus')
        },
        visitedViews: [],
        navbarData: {
            name: "mike",
            age: 24
        },
        systemTime: '',
        examineRemind: 0,       //审核消息
        whiteListType: true,    //审核 白名单状态
        auditShopInfo: 0,       // 待审核门店
    },
    mutations: {
        // 审核 通知
        SET_EXAMINE_REMIND:(state,view) => {
            state.examineRemind = view
        },
        //审核 是否白名单
        SET_WHITE_LIST_TYPE:(state,view) => {
            state.whiteListType = view
        },
        TOGGLE_SIDEBAR: state => {
            if (state.sidebar.opened) {
                Cookies.set('sidebarStatus', 1)
            } else {
                Cookies.set('sidebarStatus', 0)
            }
            state.sidebar.opened = !state.sidebar.opened
        },
        ADD_VISITED_VIEWS: (state, view) => {
            if (state.visitedViews.some(v => v.path === view.path)) return
            state.visitedViews.push({ name: view.name, path: view.path })
        },
        DEL_VISITED_VIEWS: (state, view) => {
            let index
            for (const [i, v] of state.visitedViews.entries()) {
                if (v.path === view.path) {
                    index = i
                    break
                }
            }
            state.visitedViews.splice(index, 1)
        },
        GET_NAVBAR_DATA: (state, view) => {
            state.navbarData = view
        },
        SET_AUDIT_SHOP_INFO: (state, view) => {
          state.auditShopInfo = view
        }
    },
    actions: {
        //审核消息 提醒
        getExamineRemind({ commit, rootState }){
            const agent_guid = rootState.user.agent_guid
            if (!agent_guid) return
            const parame = {
                qnbar_agent_sn: agent_guid,
                search_begin_time: '',
                search_end_time: '',
                audit_status: 3,
                keyword: '',
                page: 1,
                page_size: 15
              }
            PT.apiClient.query("/agent/interface/audit/list", parame, function (rsp) {
                console.log('审核消息',rsp)
                const num = rsp.data.total

                commit('SET_EXAMINE_REMIND', num)
            });
        },
        //审核白名单状态
        getWhiteListType({ commit, rootState }){
            const user_type = rootState.user.user_type
            if (!user_type) return
            if( user_type === 'official_staff' ){
                console.log('审核白名单oss权限')
                return commit('SET_WHITE_LIST_TYPE', true)
            }
            const parame = {
                guid: rootState.user.agent_guid
            }
            PT.apiClient.query("/bz-oss/interface/audit/whitelist/check", parame, function (rsp) {
                console.log('审核白名单',rsp)
                const type = rsp.data[0]

                commit('SET_WHITE_LIST_TYPE', type)
            });
        },
        ToggleSideBar({ commit }) {
            commit('TOGGLE_SIDEBAR')
        },
        addVisitedViews({ commit }, view) {
            commit('ADD_VISITED_VIEWS', view)
        },
        delVisitedViews({ commit, state }, view) {
            return new Promise((resolve) => {
                commit('DEL_VISITED_VIEWS', view)
                resolve([...state.visitedViews])
            })
        },
        getNavbarData({ commit }, view) {
            commit('GET_NAVBAR_DATA', view)
        },
        // 获取待审核门店信息
        getAuditShopInfo({ commit }){
          const parame = {}
          PT.apiClient.query("/agent/store/storeStatusCount", parame, function (rsp) {
            console.log('待审核门店',rsp)
            let num = rsp.data.filter(item => item.check_status == '1').map(item => item.count)[0] - 0
            console.log(num)
            commit('SET_AUDIT_SHOP_INFO', num)
          })
        }
    }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js